import { Component, OnInit, ViewChild } from "@angular/core";
import { AccountService } from "app/_services/account.service";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MatDialog } from "@angular/material";
import { SubmitSuccessComponent } from "../submit-success/submit-success.component";
import { SweetAlertService } from "ng2-sweetalert2";
import { AppState } from "@_services";
import { LanguageService } from "@_services/language.service";
import { FileuploadComponent } from "../fileupload/fileupload.component";
import { Observable } from "rxjs/Observable";
@Component({
  selector: "app-original-content",
  templateUrl: "./original-content.component.html",
  styleUrls: ["./original-content.component.scss"],
})
export class OriginalContentComponent implements OnInit {
  @ViewChild("fileupload") file: FileuploadComponent;
  openUpload = false;
  MVB: FormGroup;
  loading = false;
  currentLang: Observable<string>;
  constructor(
    public accountService: AccountService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<OriginalContentComponent>,
    public dialog: MatDialog,
    private swalService: SweetAlertService,
    private appState: AppState,
    public languageService: LanguageService
  ) {}

  ngOnInit() {
    this.MVB = this.fb.group({
      Role: new FormControl("", [Validators.required]),
      Org: new FormControl("", [Validators.required]),
      Region: new FormControl("", [Validators.required]),
      Subject: new FormControl("", [Validators.required]),
      Grades: new FormControl("", [Validators.required]),
      title: new FormControl("", [Validators.required]),
      FileGroup: this.fb.group({
        Description: new FormControl("", [Validators.required]),
        FlagCtrl: new FormControl(false),
      }),
    });
    this.currentLang = this.languageService.loadCurrentLang();
  }

  errorPop() {
    this.swalService.swal({
      title: "Error",
      text: "Something went wrong, please try again",
      type: "error",
      buttonsStyling: false,
      showCancelButton: false,
      allowOutsideClick: false,
      confirmButtonClass: "btn btn-primary  mr-4",
      confirmButtonText: "Confirm",
    });
  }

  sendTicket() {
    this.file.isClicked = true;
    if (!this.MVB.valid) return false;
    const text = this.file.FileGroup.controls["Description"].value;
    const title = this.MVB.controls["title"].value;
    const role = this.MVB.controls["Role"].value;
    const org = this.MVB.controls["Org"].value;
    const region = this.MVB.controls["Region"].value;
    const subject = this.MVB.controls["Subject"].value;
    const grades = this.MVB.controls["Grades"].value;
    this.loading = true;
    const ticket = {
      product: "mvb-0007",
      category: "myViewBoard Original Content",
      title: title,
      description:
        "Role :" +
        role +
        "\n" +
        "Organization :" +
        org +
        "\n" +
        "Region :" +
        region +
        "\n" +
        "Subject :" +
        subject +
        "\n" +
        "Grades :" +
        grades +
        "\n" +
        "Description: " +
        text,
      screenshots: this.file.keylist,
    };
    // console.log('send ticket', ticket)
    this.accountService.d365SendCase(ticket).subscribe(
      () => {
        if (this.appState._state["ticket-cases"])
          delete this.appState._state["ticket-cases"];
        this.loading = false;
        this.dialogRef.close();
        this.dialog.open(SubmitSuccessComponent, {
          width: "400px",
          minWidth: "310px",
          height: "auto",
        });
      },
      () => {
        this.loading = false;
        this.errorPop();
      }
    );
  }
}
